module.exports = __webpack_public_path__ + "static/header-af8856666a3005de241722f48560a6ad.png";